import { createFileRoute } from "@tanstack/react-router";
import { OrganizationPage } from "../features/admin/organization-page";

export const Route = createFileRoute("/_app/admin/organization")({ component: OrganizationPage });
